import react, { useState } from 'react';
import { getGuideTypeImageUrl, capitalize, getArticleByTitle } from './utils';

const API_URL = process.env.REACT_APP_API_URL || "https://the-boggler-api-96bc2fa97f2d.herokuapp.com/api";
 

const SuggestArchetype = (props) => {

    const [ encryptedPhoneNumber, setEncryptedPhoneNumber ] = useState("");
    const [ confirmationCode, setConfirmationCode ] = useState("");
    const [suggestedTitle, setSuggestedTitle] = useState("");
    const [suggestedDescription, setSuggestedDescription] = useState("");
    const [suggestedImage, setSuggestedImage] = useState(getGuideTypeImageUrl("other"));
    const [submissionMessage, setSubmissionMessage] = useState("");
    const [pronoun1, setPronoun1] = useState("she");
    const [pronoun2, setPronoun2] = useState("her");
    const [presumedGender, setPresumedGender] = useState("female");
    const [submissionStatus, setSubmissionStatus] = useState(null); // null, "submitting", "success", "error"
    const [isWhatsApp, setIsWhatsApp] = useState(false);
    const [profileImageKey, setProfileImageKey] = useState("");
    const [isDragOver, setIsDragOver] = useState(false);

    const sessionToken = window.localStorage.getItem("sessionToken");

    const uploadProfilePicture = async (file) => {
        try {
            // 1. Get pre-signed upload URL
            const urlResponse = await fetch(`${API_URL}/conversations/generate-profile-picture-url-for-suggested-guide-type`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionToken}`
                },
                body: JSON.stringify({
                    fileName: file.name,
                    fileType: file.type,
                    forSuggestedGuideType: true,
                    sessionToken: sessionToken,
                    sessionGuideNumber: props.suggestedArchetypes.length || 1
                })
            });

            const urlData = await urlResponse.json();

            if (!urlData.success) {
                console.log(urlData.message);
            }

            // 2. Upload file directly to S3
            const uploadResponse = await fetch(urlData.uploadUrl, {
                method: 'PUT',
                body: file,
                headers: {
                    'Content-Type': file.type
                }
            });

            if (!uploadResponse.ok) {
                console.log('Failed to upload to S3');
            }

            // 3. Confirm upload with your backend
            const confirmResponse = await fetch(`${API_URL}/conversations/confirm-profile-picture-upload-for-suggested-guide-type`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${sessionToken}`
                },
                body: JSON.stringify({
                    imageKey: urlData.imageKey,
                    sessionToken: sessionToken,
                    forSuggestedGuideType: true,
                    sessionGuideNumber: props.suggestedArchetypes.length || 1
                })
            });

            const confirmData = await confirmResponse.json();

            if (confirmData.success) {
                console.log('Profile picture uploaded successfully!');
                return confirmData;
            } else {
                console.log(confirmData.message);
            }

        } catch (error) {
            console.error('Error uploading profile picture:', error);
            throw error;
        }
    };

    // Usage:
    const handleFileUpload = async (selectedFile) => {

        try {

            const result = await uploadProfilePicture(selectedFile);

            setSuggestedImage(result.profilePictureURL);
            setProfileImageKey(result.imageKey);

        } catch (error) {
            alert('Upload failed: ' + error.message);
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragOver(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragOver(false);
        const files = e.dataTransfer.files;
        if (files.length > 0) {
            handleFileUpload(files[0]);
        }
    };


    return (
        <div className="guide-profile-container">
            <div className="polaroid-suggest-archetype">
                <div className="profile-photo-section">
                    <>
                        <span style={{fontWeight: "bold"}}>Suggested Archetype Image (optional):</span>
                        <div 
                            className={`file-drop-zone ${isDragOver ? 'drag-over' : ''}`}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                            onClick={() => document.getElementById('profile-picture-input').click()}
                        >
                            <div className="upload-icon">📸</div>
                            <div className="upload-text">
                                <span className="upload-text-bold">Click to upload</span>
                            </div>
                        </div>
                        <input 
                            style={{ display: 'none' }}
                            id="profile-picture-input" 
                            className="profile-picture-input"
                            onChange={(e) => handleFileUpload(e.target.files[0])} 
                            type="file" 
                            accept="image/*" 
                        />
                    </>
                    {!suggestedImage && <div>Upload an image suggestion for this archetype (optional). Note: It will be publicly displayed.</div>}
                    {submissionStatus !== "success" && suggestedImage && suggestedTitle && <div>Having a call with {getArticleByTitle(suggestedTitle)} {suggestedTitle} can be one of the best parts of your week. {capitalize(pronoun1)} {presumedGender === "either" ? "are" : "is"} helpful! {capitalize(pronoun2)} unique experience is valuable!</div>}
                    {submissionStatus == "success" && suggestedDescription && <div>{suggestedDescription}</div>}
                </div>
                <div className="caption">
                    <h2 style={{marginBottom: 0}}>Suggest an Archetype for Guides on The Boggler</h2>
                    {submissionStatus !== "success" ? (
                        <>
                            <div>
                                <label>Title of Suggested Archetype:</label><br />
                                <input 
                                    type="text" 
                                    value={suggestedTitle} 
                                    onChange={(e) => setSuggestedTitle(e.target.value)} 
                                    style={{width: "90%", padding: "8px", margin: "8px 0"}} 
                                />
                            </div>
                            <div>
                                <label>Presumed Gender for Suggested Archetype:</label><br />
                                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-around", margin: "8px 0"}}>
                                    <button className="select-presumed-gender-button" onClick={() => { setPresumedGender("male"); setPronoun1("he"); setPronoun2("his"); }} style={{backgroundColor: presumedGender === "male" ? "#4CAF50" : "#e7e7e7", color: presumedGender === "male" ? "white" : "black", marginRight: "10px"}}>Male</button>
                                    <button className="select-presumed-gender-button" onClick={() => { setPresumedGender("female"); setPronoun1("she"); setPronoun2("her"); }} style={{backgroundColor: presumedGender === "female" ? "#4CAF50" : "#e7e7e7", color: presumedGender === "female" ? "white" : "black", marginRight: "10px"}}>Female</button>
                                    <button className="select-presumed-gender-button" onClick={() => { setPresumedGender("either"); setPronoun1("they"); setPronoun2("their"); }} style={{backgroundColor: presumedGender === "either" ? "#4CAF50" : "#e7e7e7", color: presumedGender === "either" ? "white" : "black"}}>Either</button>
                                </div>
                            </div>
                            <div>
                                <label>Description of Suggested Archetype (optional):</label><br />
                                <textarea 
                                    value={suggestedDescription} 
                                    onChange={(e) => setSuggestedDescription(e.target.value)} 
                                    style={{width: "90%", padding: "8px", margin: "8px 0"}} 
                                    rows={4}
                                    maxLength="350"
                                />
                            </div>
                            <button className="submit-button" onClick={() => { props.dismiss(); props.addSuggestedArchetype({title: suggestedTitle, hyphenated_title: suggestedTitle.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, ''), description: suggestedDescription, pronoun1, pronoun2, profileImageKey: profileImageKey, presumedGender})}} style={{marginTop: "10px", padding: "10px 20px", fontSize: "18px", cursor: "pointer"}}>
                                Submit Suggestion
                            </button>
                        </>
                    ) : (
                        <div>
                            <h3>Submission Successful!</h3>
                            <p>Thank you for your suggestion!</p>
                            <button className="proceed-to-account-button" onClick={props?.dismiss}>Return to The Boggler</button>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default SuggestArchetype;